module.exports = __webpack_public_path__ + "static/Logo_Xplore_Coating_negativ-413c9bd8d72d772dc7bd9f7c760ccbb4.png";